import React from 'react';
import classNames from 'classnames/bind';
import { Input, Statistic } from '@fuxi/eevee-ui';
import { useAntLocale } from '@fuxi/eevee-hooks';
import { ACCOUNT_BIND_CODE_NUMBER } from '../../constants';
import { VERIFICATION_CODE_INPUT_LOCALE } from './helper';
import { VerificationCodeInputProps } from '.';
import { useVerificationCodeInput } from './useVerificationCodeInput';
import styles from './pc.module.less';

const cx = classNames.bind(styles);

const { Countdown } = Statistic;

export const PCVerificationCodeInput = ({
  countdownTime = 90,
  value,
  phoneNumber,
  validate,
  onChange,
  onBlur,
  msgRequest,
}: VerificationCodeInputProps) => {
  const { language } = useAntLocale();
  const { handleCaptcha, code, countDownTime, isGettingCode, onCodeChange, toggle } = useVerificationCodeInput({
    countdownTime,
    value,
    validate,
    phoneNumber,
    onChange,
    msgRequest,
  });

  return (
    <div className={cx('flex-between', 'verification-code-input-wrapper')}>
      <Input
        onBlur={onBlur}
        value={code}
        maxLength={ACCOUNT_BIND_CODE_NUMBER}
        className={cx('yaotai-verification-code-input')}
        onChange={onCodeChange}
        placeholder={VERIFICATION_CODE_INPUT_LOCALE[language]['verificationCodePlaceholder']}
      />
      {isGettingCode ? (
        <div className={cx('verification-code-button-disabled', 'yaotai-verification-code-button')}>
          <Countdown value={countDownTime} onFinish={toggle} format="s" suffix="s" />
        </div>
      ) : (
        <div className={cx('verification-code-button', 'yaotai-verification-code-button')} onClick={handleCaptcha}>
          <div id="captcha"></div>
          {VERIFICATION_CODE_INPUT_LOCALE[language]['getVerificationCode']}
        </div>
      )}
    </div>
  );
};
